import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { IconTitleMolecule } from '../../Molecules';
import { Text, Button, Input, Icon } from '../../Atoms';
import { DemandeTemplate } from '..';
import { ModalSuccessContact } from '../../Modals';
import { OrganismSelectContact } from '../../Organisms';
import { COLOR_BUTTON } from '../../Config/Config';

function TemplateContact(props) {
  const contact = () => {
    return (
      <Row className="no-margin-mob">

        <Col
          xs={12}
          md={{ order: 'first', sapn: 6 }}
          className="no-padding-mob"
        >

          <div className="container-text-description-contact-marged">
            <Text
              text="Chatbot Ceegee - Disponible 24/7"
              className="label-contact text-bold-contact web-display-none"
            /> 

            <IconTitleMolecule
              text="Chatbot Ceegee - Disponible 24/7"
              className="label-contact web-bold font-title"
              icon="sphere"
            />
            <p className="label-contact font-title">
              <span className="text-bold">Assistance continue</span> : Pour des réponses instantanées à tout moment, démarrez une conversation avec Ceegee. Il est toujours prêt à aider !
            </p>
                
            <Button
              text="Accéder au chatbot"
              className="btn-submit-contact"
              onClick={() => props.accessToChatbot()}
              color={COLOR_BUTTON.ORANGE}
            />
          </div>

          <div className="container-text-description-contact-marged">
            <Text
              text="Live Chat - Discutez avec nos conseillers"
              className="label-contact text-bold-contact web-display-none"
            />
            
            <IconTitleMolecule
              text="Live Chat - Discutez avec nos conseillers"
              className="label-contact web-bold font-title"
              icon="bubble2"
            />
            <p className="label-contact font-title">
              <span className="text-bold">Horaires du Live Chat</span> : Du lundi au vendredi de <span className="text-bold">9h à 12h et de 14h à 17h</span>. 
              Pour un échange en temps réel, dites à Ceegee : &quot;Parler à un conseiller&quot; et nous prendrons le relais.
            </p>
          </div>

          <div className="container-text-description-contact-marged">
            <Text
              text="Service Client par Téléphone"
              className="label-contact text-bold-contact web-display-none"
            />

            <IconTitleMolecule
              text="Service Client par Téléphone"
              className="label-contact web-bold font-title"
              icon="Vector10"
            />
            <p className="label-contact font-title">
              <span className="text-bold">Disponible en journée</span> : Notre équipe est à votre disposition du lundi au vendredi, de <span className="text-bold">8h30 à 17h30</span>.
            </p>
          </div>

          <div className="container-text-description-contact-marged">
            <Text
              text="Questions fréquentes"
              className="label-contact text-bold-contact web-display-none"
            />

            <IconTitleMolecule
              text="Questions fréquentes"
              className="label-contact web-bold font-title"
              icon="question-mark" size="20px"
            />
            <p className="label-contact font-title">
              <span className="text-bold">Consultez notre FAQ</span> : Accédez rapidement aux informations dont vous avez besoin et clarifiez vos doutes.
            </p>
            
            <Button
              text="Consulter la FAQ"
              className="btn-submit-contact"
              onClick={() => props.onClickFAQ()}
              color={COLOR_BUTTON.ORANGE}
            />
          </div>
          
          {/* <Input
            placeholder='Inscrivez votre adresse mail'
            className='input-contact'
            onChange={e => props.onChangeContact(e.target.value, 'mail')}
          /> */}
          {/* <OrganismSelectContact
            options={[
              { text: 'Ma caisse d’Assurance Maladie' },
              { text: 'Mes remboursements' },
              { text: 'Mes informations personnelles' },
              { text: 'Mes garanties' },
              { text: 'Mes bénéficiaires' },
              { text: 'Télétransmission liaison Noémie' },
              { text: 'Cotisation' },
              { text: 'Résiliation' },
              { text: 'Portabilité' },
              { text: 'Retraite' },
              { text: 'Mes documents' },
              { text: 'Réclamations' }
            ]}
            onChange={(e) => props.onChangeContact(e, 'object')}
            value={props.state.contact.object}
          />
          <Input
            placeholder="Ecrivez votre message ici"
            className="input-contact contact-text-area"
            onChange={(e) => props.onChangeContact(e.target.value, 'message')}
          />
          <Upload
            style={{ height: '1px' }}
            handleFileChange={(e) => props.onChangeContact(e, 'file')}
            size="small"
            containerClassName="container-contact-input-file"
          />
          {/* <Text text='PDF, JPEG -  5mo maximum autorisé' className='condition-upload-doc-hospitalisation' /> 
          <div className="container-end">
            <Button
              text="Envoyer"
              className="btn-submit-contact"
              onClick={() => props.onSubmit()}
            />
          </div> */}
        </Col>
      </Row>
    );
  };
  const demande = () => {
    return (
      <DemandeTemplate
        demandeData={props.demandeData}
        demandeStep={props.demandeStep}
        viewClicked={props.viewClicked}
        selectedDemande={props.selectedDemande}
        responseClicked={props.responseClicked}
        viewDemandeClicked={props.viewDemandeClicked}
        retourClicked={props.retourClicked}
        page={props.page}
        pageNumber={props.pageNumber}
        onChangePagination={props.onChangePagination}
        demandeDataMobile={props.demandeDataMobile}
        value={props.searchWord}
        onKeyPress={props.onKeyPress}
        OnLoopIconClick={props.OnLoopIconClick}
        onChange={props.onChange}
        sortClicked={props.sortClicked}
        response={props.response}
        responseChanged={props.responseChanged}
        sendResponse={props.sendResponse}
      />
    );
  };
  const contactStyle = () => {
    if (props.state.status === 'Nous contacter') {
      return 'title-contact remboursement-title-active';
    }
    return 'title-contact';
  };
  const demandeStyle = () => {
    if (props.state.status === 'Mes demandes') {
      return 'title-contact remboursement-title-active';
    }
    return 'title-contact';
  };
  return (
    <div
      className="template-notification temlplate-contact template-scroll"
      onScroll={props.onScroll}
    >
      <div className="title-contact-container">
        <Text
          text={<span className={contactStyle()}>Nous contacter</span>}
          onClick={() => props.changeStatus('Nous contacter')}
        />
        <Text
          text={<span className={demandeStyle()}>Mes demandes</span>}
          onClick={() => props.changeStatus('Mes demandes')}
        />
      </div>
      {props.state.status === 'Nous contacter' ? contact() : demande()}
      <ModalSuccessContact show={props.state.show} onHide={props.onHide} />
    </div>
  );
}

TemplateContact.propTypes = {
  accessToChatbot: PropTypes.func,
  onClickFAQ: PropTypes.func,
  onHide: PropTypes.func,
  state: PropTypes.string,
  demandeData: PropTypes.any,
  demandeStep: PropTypes.any,
  viewClicked: PropTypes.any,
  selectedDemande: PropTypes.any,
  responseClicked: PropTypes.any,
  viewDemandeClicked: PropTypes.any,
  retourClicked: PropTypes.any,
  page: PropTypes.any,
  pageNumber: PropTypes.any,
  onChangePagination: PropTypes.any,
  demandeDataMobile: PropTypes.any,
  searchWord: PropTypes.any,
  onKeyPress: PropTypes.any,
  OnLoopIconClick: PropTypes.any,
  onChange: PropTypes.any,
  sortClicked: PropTypes.any,
  response: PropTypes.any,
  responseChanged: PropTypes.any,
  sendResponse: PropTypes.any,
  onScroll: PropTypes.any,  
  changeStatus: PropTypes.func
};

TemplateContact.defaultProps = {
  state: {
    status: 'Nous contacter'
  }
};

export default TemplateContact;
